import React, { useEffect, useState } from "react";
import "./auth.scss";
import promoIllustration from "./assets/images/promo_illustration.png";
import whiteLogo from "./assets/images/logo_white.png";
import blackLogo from "./assets/images/logo_black.png";
import { useMutation } from "react-query";
import cogoToast from "cogo-toast";
import jwtDecode from "jwt-decode";
import { useHistory } from "react-router-dom";
import { login } from "./authbackendservices";
import { useLocation } from "react-router-dom";

const LoginDesign = () => {
    const [logoImage, setLogoImage] = useState(whiteLogo); // Default logo
    const [showPassword, setShowPassword] = useState(false);
    const [memberId, setMemberId] = useState("");
    const [password, setPassword] = useState("");
    const [otpValue, setOtpValue] = useState("");
    const [isRememberMe, setIsRememberMe] = useState(false);
    const [isOtpShown, setIsOtpShown] = useState(false);
    const [otpType, setOtpType] = useState(""); //for check otp type is maol or google auth
    const history = useHistory();
    const location = useLocation();

    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };

    // Update the logo based on screen size
    const updateLogo = () => {
        if (window.innerWidth < 995) {
            setLogoImage(blackLogo); // Use black logo if width is less than 995px
        } else {
            setLogoImage(whiteLogo); // Use white logo if width is greater than or equal to 995px
        }
    };

    // If query params has the valid token then redirect to dashboard
    const isTokenExists = () => {
        // If the user has token in query params and is valid then redirect admin to the dashboard directly
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get("token");
        if (token) {
            const decodedToken = jwtDecode(token);
            // Check if the token is expired
            const currentTime = Date.now() / 1000; // Current time in seconds
            if (decodedToken.exp > currentTime) {
                // Setting the token and redirecting the user
                localStorage.setItem("user_access_token", token);
                history.push({
                    pathname: "/dashboard",
                });
            }
            return true;
        }
        return false;
    };

    // If the tokenis there in the local storage and the is_remember is on then redirect user to dashboard directly
    const isRemember = () => {
        let is_remember_on = localStorage.getItem("is_remember_on");
        let user_token = localStorage.getItem('user_access_token');
        if (is_remember_on && user_token) {
            const decodedToken = jwtDecode(user_token);
            // Check if the token is expired
            const currentTime = Date.now() / 1000; // Current time in seconds
            if (decodedToken.exp > currentTime) {
                history.push({
                    pathname: "/dashboard",
                });
            }
            return true;
        }
        return false;
    }

    // Add event listener for resizing window
    useEffect(() => {

        // If the login is done from admin and token is passed in the query params 
        // And return because preventing from executing the lines after this
        if (isTokenExists()) return;

        // If is Remember on and their is valid user_access_token then redirect it to the dashboard directly         
        // And return because preventing from executing the lines after this
        if (isRemember()) return;

        updateLogo(); // Set initial logo based on current screen width

        window.addEventListener("resize", updateLogo); // Add resize event listener

        return () => {
            window.removeEventListener("resize", updateLogo); // Clean up event listener
        };
    }, []);

    const validateLoginParams = () => {
        if (isOtpShown) {
            if (otpValue == "") {
                cogoToast.warn("Enter Otp", { hideAfter: 3 });
                return false;
            }
        }
        if (memberId == "") {
            cogoToast.warn("Enter UserId or Username", { hideAfter: 3 });
            return false;
        }
        if (password == "") {
            cogoToast.warn("Enter Password", { hideAfter: 3 });
            return false;
        }
        return true;
    }

    const handleMemberID = (value) => {
        // Regex to allow only alphanumeric characters, dots, and special characters (@, -, .)
        const allowedPattern = /^[a-zA-Z0-9.@-]*$/;

        // Check if the value matches the allowed pattern (no invalid characters)
        if (allowedPattern.test(value)) {
            // Update the memberId state with the valid input
            setMemberId(value);
        } else {
            // Optionally, you can show an error message or prevent invalid characters from appearing
            cogoToast.error("Only letters, digits, and .@- are allowed", { hideAfter: 3 });
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateLoginParams()) {
            return; // Stop form submission if validation fails
        }

        const login_data = {
            member_id: memberId,
            password: password
        }
        if (isOtpShown) {
            login_data.otp_value = Number(otpValue);
        }
        loginMutation.mutate(login_data);
    };

    const resetvalues = () => {
        setOtpType(""); // Reset OTP type
        setMemberId("");
        setPassword("");
        setOtpValue();
        setIsRememberMe(false);
        setIsOtpShown(false);
        setLogoImage(whiteLogo);
        setShowPassword(false);
    }

    // API call login user
    const loginMutation = useMutation("login", (values) =>
        login(values)
            .then((res) => {
                if (res.type == "token") {
                    localStorage.setItem("user_access_token", res.data);
                    localStorage.setItem("is_remember_on", isRememberMe);
                    cogoToast.success(res.msg || "User logged-in successfully!", { hideAfter: 3, });
                    resetvalues();
                    history.push({
                        pathname: "/dashboard",
                    });
                    return;
                }
                if (res.type === "otp" || res.type === "totp") {
                    setIsOtpShown(true);
                    setOtpType(res.type); // Set OTP type
                    cogoToast.success(res?.msg, { hideAfter: 3 });
                    return;
                }
                if (res.type === "otp-expired") {
                    setIsOtpShown(false);
                    setOtpType(""); // Set OTP type
                    setOtpValue("");
                    cogoToast.error(res?.msg || "OTP is Expired.", { hideAfter: 3 });
                    return;
                }
                if (res.type === "otp-invalid") {
                    cogoToast.error(res.msg ?? "OTP is Invalid.", { hideAfter: 3 });
                    return;
                }
                if (res.type == "error") {
                    if (res.flag == "freezed") {
                        cogoToast.error("Your Account is Freezed. Please contact Admin to unlock the Account.", { hideAfter: 5 });
                    } else if (res.flag == "suspended") {
                        cogoToast.error("Your Account is Suspended. Please contact Admin to unlock the Account.", { hideAfter: 5 });
                    } else if (res.flag == "blocked") {
                        cogoToast.error("Your Account is Blocked. Please contact Admin to unlock the Account.", { hideAfter: 5 });
                    } else {
                        cogoToast.error(res.msg || "Failed to logged-in.", { hideAfter: 5, });
                    }
                    return;
                }
                cogoToast.error(res.msg || "Failed to logged-in.", {
                    hideAfter: 3,
                });
            })
            .catch((e) => {
                console.log("error : ", e);
            })
    );

    return (
        <div className="auth-container">
            <div className="container-fluid vh-100 d-flex flex-column p-0">
                {/* Top Left Logo */}
                <div className="top-left-logo">
                    <img
                        src={logoImage}
                        alt="Logo"
                        className="img-fluid"
                    />
                </div>

                <div className="d-flex flex-grow-1">
                    {/* Left Section */}
                    <div className="left-section">
                        <img
                            src={promoIllustration}
                            alt="Promo Illustration"
                            className="img-fluid"
                        />
                    </div>

                    {/* Right Section */}
                    <div className="right-section">
                        <div className="content-box">
                            <h3 className="text-primary text-center">LOGIN</h3>
                            <h4 className="fw-semibold">WELCOME TO ARBITFX!</h4>
                            <p className="text-muted">Please sign-in to your account and start the adventure.</p>

                            <form action="">
                                {/* User ID or Username Input */}
                                <div className="form-group has-float-label">
                                    <input
                                        className="form-control input-radius"
                                        id="user_id_or_name"
                                        type="text"
                                        placeholder="Enter your UserID or Username"
                                        value={memberId}
                                        disabled={isOtpShown}
                                        onChange={(e) => {
                                            handleMemberID(e.target.value);
                                        }}
                                    />
                                    <label htmlFor="user_id_or_name">UserID or Username</label>
                                </div>

                                {/* Password Input with Toggle */}
                                <div className="form-group has-float-label mt-3"> {/* Reduced top margin */}
                                    <div className="input-group input-group-merge">
                                        {/* Password Input Field with Floating Label */}
                                        <div className="form-floating form-floating-outline flex-grow-1">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control input-radius"
                                                id="password"
                                                placeholder="Enter Password"
                                                style={{
                                                    paddingRight: '2.5rem' // Adds space for the eye icon
                                                }}
                                                value={password}
                                                disabled={isOtpShown}
                                                onChange={(e) => {
                                                    setPassword(e.target.value);
                                                }}
                                            />
                                            <label htmlFor="password">Password</label>
                                        </div>

                                        {/* Eye Toggle Icon */}
                                        <span
                                            className="input-group-text cursor-pointer eye-icon-radius position-absolute end-0 pe-3 bg-light"
                                            onClick={togglePasswordVisibility}
                                            style={{
                                                height: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                right: '0',
                                            }}
                                        >
                                            <i className={`mdi ${showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'}`}></i>
                                        </span>
                                    </div>
                                </div>

                                {/* OTP Input */}
                                {isOtpShown && (
                                    <div className="form-group has-float-label mt-2">
                                        <input
                                            className="form-control  input-radius"
                                            id="otp_value"
                                            type="number"
                                            placeholder={
                                                otpType === "otp"
                                                    ? "Enter your OTP"
                                                    : "Enter your Google Authenticator Code"
                                            }
                                            value={otpValue}
                                            onChange={(e) => {
                                                setOtpValue(e.target.value);
                                            }}
                                        />
                                        <label htmlFor="otp_value">
                                            {otpType === "otp" ? "OTP" : "Google Authenticator Code"}
                                        </label>
                                    </div>
                                )}


                                {/* Checkbox and Forgot Password Section */}
                                <div className="form-group mt-2"> {/* Reduced margin-top here */}
                                    <div className="d-flex justify-content-between align-items-center">
                                        {/* Remember Me Checkbox */}
                                        <div className="form-check d-flex align-items-center ">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="rememberMe"
                                                value={isRememberMe}
                                                onChange={(e) => {
                                                    setIsRememberMe(e.target.checked);
                                                }}
                                                style={{ transform: 'scale(1.5)', marginRight: '0.5rem' }} // Added margin-right for spacing between checkbox and label
                                            />
                                            <label className="form-check-label" htmlFor="rememberMe" style={{ fontSize: '1rem' }}>
                                                Remember Me
                                            </label>
                                        </div>

                                        {/* Forgot Password Link */}
                                        <span className="forgot-password text-decoration-none clickable-cursor" onClick={() => {
                                            history.push({
                                                pathname: "/forgotpassword",
                                            });
                                        }} style={{ fontSize: '0.875rem' }}>
                                            Forgot Password?
                                        </span>
                                    </div>
                                </div>

                                {/* Sign In Button */}
                                <div className="d-flex justify-content-center mt-4">
                                    <button className="btn w-100 text-white rounded"
                                        disabled={loginMutation.isLoading}
                                        onClick={handleSubmit}
                                        style={{ fontSize: '1rem', padding: '0.75rem', backgroundColor: "#353C6A" }}
                                    >
                                        {loginMutation.isLoading ? "Loading..." : "Sign In"}
                                    </button>
                                </div>

                                {/* New on our platform? Create an Account Link */}
                                <div className="d-flex justify-content-center mt-3">
                                    <span style={{ fontSize: '0.875rem' }}>
                                        New on our platform?{' '}
                                        <span className="ms-2 clickable-cursor" onClick={() => {
                                            history.push({
                                                pathname: "/registration",
                                            });
                                        }} style={{ color: 'blue', textDecorspantion: 'none' }}>
                                            Create an Account
                                        </span>
                                    </span>
                                </div>
                            </form>

                        </div>
                    </div>

                </div>
            </div >
        </div>
    );
};

export default LoginDesign;